import { TimelineLite } from 'gsap';

class AnimationDrawer {
  spin(texture, duration = .5) {
    return new TimelineLite()
      .to(texture, { duration, rotation: 25 * (Math.PI / 180) })
      .to(texture, { duration, rotation: 0 });
  }

  blinking(texture, duration = .2, scales = [1.5, .5, 1]) {
    return scales.reduce((timelineLite, scale) => {
      return timelineLite.to(texture, { duration, pixi: { scale: scale } });
    }, new TimelineLite());
  }
}

export const animationDrawer = new AnimationDrawer();
